import React from 'react';
import { useTranslation } from 'react-i18next';
import './StepIndicator.css';

interface Step {
  key: string;
  titleKey: string;
  completed: boolean;
  active: boolean;
}

interface StepIndicatorProps {
  currentStep: 'validate' | 'phone' | 'otp' | 'card';
  completedSteps: string[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, completedSteps }) => {
  const { t } = useTranslation();

  const steps: Step[] = [
    {
      key: 'validate',
      titleKey: 'steps.validate',
      completed: completedSteps.includes('validate'),
      active: currentStep === 'validate',
    },
    {
      key: 'phone',
      titleKey: 'steps.phone',
      completed: completedSteps.includes('phone'),
      active: currentStep === 'phone',
    },
    {
      key: 'otp',
      titleKey: 'steps.otp',
      completed: completedSteps.includes('otp'),
      active: currentStep === 'otp',
    },
    {
      key: 'card',
      titleKey: 'steps.card',
      completed: completedSteps.includes('card'),
      active: currentStep === 'card',
    },
  ];

  return (
    <div className="step-indicator">
      {steps.map((step, index) => (
        <div key={step.key} className={`step ${step.active ? 'active' : ''} ${step.completed ? 'completed' : ''}`}>
          <div className="step-number">
            {step.completed ? (
              <span className="checkmark">✓</span>
            ) : (
              <span>{index + 1}</span>
            )}
          </div>
          <div className="step-label">{t(step.titleKey)}</div>
          {index < steps.length - 1 && <div className="step-connector" />}
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;